import React from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { t, fmtDistance, clock, osmLink } from "../helpers/format"

const Position = ({ label, time, position, radius }) => {
  const outside = position.distance != null && radius != null && Number(position.distance) > Number(radius)
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span
        className = {clsx(
          "inline-grid place-items-center w-[22px] h-[22px] shrink-0 rounded-full text-[10px]",
          outside ? "bg-amber-100 text-amber-600" : "bg-emerald-50 text-emerald-600"
        )}
      >
        <FontAwesomeIcon icon="location-dot" />
      </span>
      <div className="min-w-0 flex-1 text-[11.5px] leading-[1.25]">
        <div className="text-slate-700">
          <span className="font-semibold">{label}</span>
          {time && <span className="tabular-nums text-slate-500"> · {time}</span>}
        </div>
        <div className="text-slate-500 truncate">
          {position.distance != null
            ? t("gps.distance", { distance: fmtDistance(position.distance) })
            : t("gps.no_site")}
          {position.accuracy ? ` · ${t("gps.accuracy", { meters: Math.round(position.accuracy) })}` : ""}
        </div>
      </div>
      {outside && (
        <span className="shrink-0 px-1.5 py-[1px] rounded-full bg-amber-50 ring-1 ring-inset ring-amber-200 text-[10.5px] font-semibold text-amber-700">
          {t("gps.outside")}
        </span>
      )}
      <a
        href      = {osmLink(position.latitude, position.longitude)}
        target    = "_blank"
        rel       = "noopener noreferrer"
        className = "shrink-0 inline-flex items-center gap-1 text-[11px] font-medium text-brand-600 hover:text-brand-700 hover:underline"
      >
        {t("gps.map")}
        <FontAwesomeIcon icon="arrow-up-right-from-square" className="text-[9px]" />
      </a>
    </div>
  )
}

const GpsPositions = ({ entry, radius }) => {
  if (!entry.start_position && !entry.end_position) return null
  return (
    <div className="mt-3 pt-3 border-t border-slate-100 flex flex-col gap-2">
      {entry.start_position && (
        <Position label={t("gps.start")} time={clock(entry.started_at)} position={entry.start_position} radius={radius} />
      )}
      {entry.end_position && (
        <Position label={t("gps.end")} time={clock(entry.ended_at)} position={entry.end_position} radius={radius} />
      )}
    </div>
  )
}

export default GpsPositions
